// Language Service for Internationalization
export type Language = 'en' | 'ru';

interface LanguageSettings {
  currentLanguage: Language;
}

class LanguageService {
  private settings: LanguageSettings = {
    currentLanguage: 'en',
  };

  constructor() {
    this.loadSettings();
  }

  // Load settings from localStorage
  private loadSettings(): void {
    const saved = localStorage.getItem('languageSettings');
    if (saved) {
      try {
        this.settings = JSON.parse(saved);
      } catch (error) {
        console.error('Failed to load language settings:', error);
      }
    }
  }

  // Save settings to localStorage
  private saveSettings(): void {
    localStorage.setItem('languageSettings', JSON.stringify(this.settings));
  }

  // Get current language
  getCurrentLanguage(): Language {
    return this.settings.currentLanguage;
  }

  // Set language
  setLanguage(language: Language): void {
    this.settings.currentLanguage = language;
    this.saveSettings();
  }
}

export const languageService = new LanguageService();

